module.exports = __webpack_public_path__ + "img/tretonian-color.75eba2e.svg";